import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Avatar,
  CardHeader,
  Box,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { assingMultipleDriver } from "../../redux/accionesDrivers";
import { customLocaleText } from "../../utils/objects/CustomLocaleTextTables";

const PopUpAsignament = ({
  ordersForAccions,
  ridersDataByCompany,
  opemPopUpAsignament,
  setOpemPopUpAsignament,
  handleUpdate,
  routesDataOrdersForAccions = [],
}) => {
  // console.log("PopUpAsignament ordersForAccions:", ordersForAccions);

  // console.log(
  //   "PopUpAsignament routesDataOrdersForAccions:",
  //   routesDataOrdersForAccions
  // );

  const response = useSelector((store) => store.usuarioDriver.response);

  const [selectedRider, setSelectedRider] = useState(null);
  const [notPickedUpCount, setNotPickedUpCount] = useState(0);
  const [apiResponses, setApiResponses] = useState("");
  const [apiError, setApiError] = useState("");
  const [enabledRidersDataByCompany, setEnabledRidersDataByCompany] = useState(
    []
  );

  const dispatch = useDispatch();

  // solo puede asignar ordenes si isPickedUp === true si routesDataOrdersForAccions es un array vacio ignora esta nueva funcionalidad y asigna las ordenes directamente sin filtrar

  useEffect(() => {
    if (ridersDataByCompany.length > 0) {
      let enableRiders = ridersDataByCompany.filter(
        (rider) => !rider.hiddenListMenus
      );
      setEnabledRidersDataByCompany(enableRiders);
    }
  }, [ridersDataByCompany]);

  useEffect(() => {
    if (!response) return;

    const ok =
      response?.status === "success" || response?.result?.status === "success";

    if (ok) {
      if (handleUpdate) handleUpdate();
      handleClose();
    }
  }, [response]);

  useEffect(() => {
    if (opemPopUpAsignament) {
      const notPicked = routesDataOrdersForAccions.filter(
        (order) => !order.isPickedUp
      );
      setNotPickedUpCount(notPicked.length);
    }
  }, [opemPopUpAsignament, ordersForAccions]);

  // Función para dividir el array en lotes de tamaño 'size'
  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  // PopUpAsignament: envía TODO en 1 llamada (deja el batching al backend)
  /** 
  const asignarConductor = async () => {
    if (!selectedRider) return;

    const normalizeID = (id) => (String(id).startsWith("F") ? id : "F" + id);

    // Convertir array a Set para búsquedas eficientes
    const ordersForAccionsSet = new Set(ordersForAccions);

    // -----------------------------
    // 1) Construir lista de órdenes
    // -----------------------------
    let filteredOrders = [];

    if (routesDataOrdersForAccions.length > 0) {
      // a) Hay rutas escaneadas → intersecto con ordersForAccions
      //    y aplico isPickedUp === true
      filteredOrders = routesDataOrdersForAccions
        .filter(
          (o) =>
            ordersForAccionsSet.has(normalizeID(o.id)) && o.isPickedUp === true
        )
        .map((o) => normalizeID(o.id));
    } else {
      // b) No hay rutas escaneadas → uso TODO ordersForAccions, sin filtro
      filteredOrders = Array.from(ordersForAccions);
    }

    // -----------------------------
    // 2) Validación
    // -----------------------------
    if (filteredOrders.length === 0) {
      const msg =
        "No se puede asignar órdenes: ninguna está marcada con escáner de bodega.";
      console.log(msg);
      setApiError(msg);
      return;
    }

    //  console.log("Filtered Orders:", filteredOrders.length);

    // -----------------------------
    // 3) Chunk y dispatch
    // -----------------------------
    const batches = chunkArray(filteredOrders, 20);

    try {
      for (const batch of batches) {
        await dispatch(
          assingMultipleDriver({
            data: {
              driverID: selectedRider.id,
              orderIDs: batch,
            },
          })
        );
      }
    } catch (error) {
      console.error("Error al asignar conductor:", error);
      setApiError(error.message || "Error desconocido");
    }
  };
  */

  const asignarConductor = async () => {
    if (!selectedRider) return;

    const normalizeID = (id) => (String(id).startsWith("F") ? id : "F" + id);
    const ordersForAccionsSet = new Set(ordersForAccions);

    let filteredOrders = [];

    if (routesDataOrdersForAccions.length > 0) {
      filteredOrders = routesDataOrdersForAccions
        .filter(
          (o) =>
            ordersForAccionsSet.has(normalizeID(o.id)) && o.isPickedUp === true
        )
        .map((o) => normalizeID(o.id));
    } else {
      filteredOrders = Array.from(ordersForAccions);
    }

    if (filteredOrders.length === 0) {
      const msg =
        "No se puede asignar órdenes: ninguna está marcada con escáner de bodega.";
      setApiError(msg);
      return;
    }

    // ✅ UNA sola llamada: el proxy parte en lotes y reintenta
    const res = await dispatch(
      assingMultipleDriver({
        data: { driverID: selectedRider.id, orderIDs: filteredOrders },
      })
    );

    // ✅ soporta ambos shapes (proxy o legacy)
    const ok = res?.status === "success" || res?.result?.status === "success";

    if (ok) {
      if (handleUpdate) handleUpdate();
      handleClose();
    } else {
      setApiError("Error en la asignación.");
    }
  };

  const handleClose = () => setOpemPopUpAsignament(false);

  const handleRowClick = (params) => {
    setSelectedRider({
      id: params.id,
      name: params.row.name,
      avatar: params.row.avatar,
    });
  };

  const columnsRiders = [
    {
      field: "conductor",
      headerName: "Seleccione un conductor",
      flex: 1, // 🔥 Hace que la columna se expanda automáticamente según el ancho disponible
      minWidth: 350, // 🔥 Asegura que la columna tenga suficiente espacio
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 🔥 Alinear verticalmente al centro
            justifyContent: "start", // 🔥 Alinear elementos a la izquierda
            width: "100%", // 🔥 Asegura que ocupe todo el ancho disponible

            // 🔥 Añadir un poco de espacio interno
          }}
        >
          {/* 📌 Avatar con un tamaño adecuado */}
          <Box>
            <Avatar
              src={params.row.avatar}
              sx={{ width: 45, height: 45, ml: 1 }}
            />
          </Box>
          {/* 📌 Contenedor para el nombre y el número de conductor */}
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              {params.row.name}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {params.row.bicciNumber}
            </Typography>
          </Box>
        </Box>
      ),
    },
  ];

  // console.log(ordersForAccions);
  return (
    <Dialog
      open={opemPopUpAsignament}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          width: { xs: "100%", sm: "100%", md: "700px" },
          maxWidth: "700px",
        },
      }}
    >
      <DialogTitle id="form-dialog-title">Asignar conductor</DialogTitle>
      <DialogContent>
        <Box
          sx={{ width: "100%", height: 40, p: 1, backgroundColor: "#fafafa" }}
        >
          Envíos seleccionados para asignar : {ordersForAccions.length}
        </Box>
        {routesDataOrdersForAccions.length > 0 && notPickedUpCount > 0 && (
          <Box
            sx={{
              width: "100%",
              p: 1,
              backgroundColor: "#fff5f5",
              color: "#d32f2f",
            }}
          >
            ⚠️ {notPickedUpCount} órdenes no están confirmadas con escáner de
            bodega. Estas no serán asignadas.
          </Box>
        )}
        <Box
          sx={{
            width: "100%",
            height: "auto",
            backgroundColor: "#fafafa",
            minHeight: 350,
          }}
        >
          {enabledRidersDataByCompany && (
            <DataGrid
              sx={{ minHeight: "150px", width: "750px" }} // 🔹 Asegurar que ocupe todo el ancho disponible
              rows={enabledRidersDataByCompany}
              columns={columnsRiders}
              pageSize={500}
              rowsPerPage={[5, 100, 500]}
              pagination
              localeText={customLocaleText}
              groupingModel={["name"]}
              onRowClick={handleRowClick}
            />
          )}
        </Box>

        {selectedRider && (
          <CardHeader
            avatar={<Avatar src={selectedRider.avatar} />}
            title={selectedRider.name}
          />
        )}

        {/**
        {apiResponses.length > 0 && (
          <div>
            <Typography variant="h6" gutterBottom>
              Respuestas de la API:
            </Typography>
            <Alert severity={response ? "success" : "error"} sx={{ mb: 2 }}>
              <AlertTitle>Lote </AlertTitle>
              {response || "Operación realizada."}
            
            </Alert>
          </div>
        )}

        {apiError && (
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            {apiError}
          </Alert>
        )}
 */}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancelar
        </Button>
        {ordersForAccions.length > 0 ? (
          <Button onClick={asignarConductor} color="primary">
            Asignar conductor
          </Button>
        ) : (
          <Button color="primary">0 envíos seleccionados</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PopUpAsignament;
